export function platformGet(): 'mobile' | 'tablet' | 'desktop' {
  if (window.innerWidth < 768) {
    return 'mobile'
  } else if (window.innerWidth < 1096) {
    return 'tablet'
  } else {
    return 'desktop'
  }
}
